<template>
  <!-- 咨询内容页 -->
  <div class="consultdet">
    <div class="w12 between">
      <lvbreadcrumb class="speltmbx" :tolist="tolist" />
      <div class="consultdetlef">
        <cutdetletop class="bgff" />
        <cdetchitolaw class="mt30 bgff" />
        <cdetyzhttj class="mt30 bgff" />
      </div>
      <div class="consultdetrig">
        <cdethottopic class="bgff" />
        <detrecomvideo class="mt30 bgff" />
      </div>
    </div>
  </div>
</template>
<script>
import lvbreadcrumb from "components/content/lvbreadcrumb/lvbreadcrumb";
import cutdetletop from "./child/cutdetletop";
import cdetchitolaw from "./child/cdetchitolaw";
import cdetyzhttj from "./child/cdetyzhttj";
import cdethottopic from "./child/cdethottopic";
import detrecomvideo from "views/articimdet/components/detrecomvideo";

export default {
  components: {
    lvbreadcrumb,
    cutdetletop,
    cdetchitolaw,
    cdetyzhttj,
    cdethottopic,
    detrecomvideo,
  },
  data: () => ({
    tolist: [
      {
        name: "首页",
        pathname: "home",
      },
      {
        name: "热门资讯",
        pathname: "hotconsult",
      },
      {
        name: "离婚后探视权是这么规定的",
        pathname: "consultdet",
      },
    ],
  }),
};
</script>

<style lang='scss' scoped>
.consultdet {
  background-color: #f8f8f8;
  .w12 {
    width: 1200px;
    align-items: flex-start;
    margin: 0 auto;
    padding: 50px 0;
    position: relative;

    .bgff {
      background: #ffffff;
    }
    .consultdetlef {
      width: 856px;
    }
    .consultdetrig {
      width: 314px;
    }
  }

  .speltmbx {
    position: absolute;
    top: 20px;
    left: 0;
  }
}
</style>